import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Enquiry from './pages/Enquiry';
import Contact from './pages/Contact';

import './assets/css/plugins.css';
import './assets/css/style.css';
import './assets/css/services.css';
import './assets/css/contact.css';
import './assets/css/about.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import Blog from './components/Blog/Blog';
import DestinationDetails from './components/Destination/DestinationDetails';
import BookDestination from './components/Destination/BookDestination';

import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';
import CreatePaymentLink from './components/Admin/CreatePaymentLink';
import PaymentLinksList from './components/Admin/PaymentLinksList';
import ProtectedRoute from './components/Admin/ProtectedRoute';

import PaymentPage from './components/Payment/PaymentPage';
import PaymentSuccess from './components/Payment-Status/PaymentSuccess';
import PaymentFailed from './components/Payment-Status/PaymentFailed';
import PaymentLinkPage from './components/Payment/PaymentLinkPage';

function AppContent() {

  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith('/admin');
  const isPayRoute = location.pathname.startsWith('/pay');

  return (
    <div className="vs-body">

      {!isAdminRoute && !isPayRoute && <Header />}

      <main className="main">

        <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/enquiry" element={<Enquiry />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/blog" element={<Blog />} />
          <Route path="/destinationdetails" element={<DestinationDetails />} />

          <Route path="/book/:packageId" element={<BookDestination />} />
          <Route path="/bookdestination" element={<Navigate to="/book/south-india-korea" replace />} />

          <Route path="/payment/:id" element={<PaymentPage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
          <Route path="/pay/:linkId" element={<PaymentLinkPage />} />

          <Route path="/admin/login" element={<AdminLogin />} />

          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/create-payment-link"
            element={
              <ProtectedRoute>
                <CreatePaymentLink />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/payment-links"
            element={
              <ProtectedRoute>
                <PaymentLinksList />
              </ProtectedRoute>
            }
          />

          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>

      </main>

      {!isAdminRoute && !isPayRoute && <Footer />}

    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;